import { Component, inject, input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { isEqual } from 'lodash';
import { DirectoryNumberRef, TranslationPatternRef } from '../../../shared/models/generated/ziroModels';
import { DnDetailService } from '../../shared/services/dn-detail.service';

@Component({
  selector: 'ziro-dn-detail-summary-info',
  templateUrl: './dn-detail-summary-info.component.html',
  standalone: false,
})
export class ZiroDnDetailSummaryInfoComponent implements OnInit, OnChanges {
  private dnDetailService = inject(DnDetailService);

  readonly translationPatternRef = input<TranslationPatternRef[]>();
  readonly directoryNumberRef = input<DirectoryNumberRef>();

  did: string;
  didLink: string;

  ngOnInit(): void {
    this._throwErrorIfThereAreMultipleDids();
    this._setDid();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.translationPatternRef &&
      !isEqual(changes.translationPatternRef.currentValue, changes.translationPatternRef.previousValue)
    ) {
      this._setDid();
    }
  }

  extensionLink(): string {
    return this.directoryNumberRef() ? `tel:${this.directoryNumberRef().extension}` : '';
  }

  private _setDid(): void {
    const did = this.dnDetailService.getDid(this.translationPatternRef(), false);

    if (did) {
      this.did = did.pattern;
      this.didLink = 'tel:' + did.pattern;
    } else {
      this.did = null;
      this.didLink = null;
    }
  }

  private _throwErrorIfThereAreMultipleDids(): void {
    this.dnDetailService.getDid(this.translationPatternRef(), true);
  }
}
